import React from "react";

import MyHomeworksCatalogRoot from "../mainApp/containers/MyHomeworksCatalogRoot";

const MyHomeworksModule = props => (
  <MyHomeworksCatalogRoot {...props} />
);

export default MyHomeworksModule;
